import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LOCALES } from './locales.js';

export const LOCALE_STORAGE_KEY = 'ar:locale';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED_LOCALES.map((l) => l.code),
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'agents', 'chat', 'settings', 'errors'],
    load: 'languageOnly',
    debug: true,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      requestOptions: { cache: 'no-store' },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  })
  .then((t) => {
    console.log(
      '[i18n] ✅ init complete — language:',
      i18n.language,
      '| t("common:save"):',
      t('common:save'),
    );
  })
  .catch((err) => {
    console.error('[i18n] ❌ init failed:', err);
  });

i18n.on('languageChanged', (lng) => {
  console.log('[i18n] 🔄 languageChanged event fired →', lng);
});

i18n.on('failedLoading', (lng, ns, msg) => {
  console.error('[i18n] ❌ failedLoading:', lng, ns, msg);
});

i18n.on('loaded', (loaded) => {
  console.log('[i18n] 📦 loaded resources:', loaded);
});

export default i18n;
